import React, { useState } from 'react';
import {
  Container,
  Collapse,
  Navbar,
  NavbarToggler,
} from 'reactstrap';
import { Link } from "gatsby-plugin-modal-routing"
import { Nav, NavItem, NavLink, UncontrolledDropdown, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, ButtonDropdown} from 'reactstrap';
import Linkks from './link';
import {  CardBody, Card } from 'reactstrap';
import styled from 'styled-components'



let Btn = styled.div`
  -webkit-appearance: unset !important;
  border-radius: 0.25rem;
  background: ${props => props.theme.primary};
  box-shadow: 0 .5rem 1.5rem rgba(22,28,45,.1);
  color: white;
  display: inline-block;
  padding: .8125rem 1.25rem;
  font-size: x-large;

`
function sortListName(list) {
  return list.sort(
    (a, b) => a.node.frontmatter.title - b.node.frontmatter.title
  );
}


  const isHere=(link, className, name, here)=> {
    if (link===here) {
      return (
        <NavItem>
          <Link to={link} className={className + " lineUp"} >{name}</Link>
        </NavItem>
      );
    } else {
      return (
        <NavItem>
        <NavLink href={link} active className={className}>{name}</NavLink>
      </NavItem>
        );
    }
    } 

 
let CustomNavItem = ({ link, className, name, here }) => (
  isHere(link, className, name, here)
)


const Header = (props) => {
  //console.log(props);
  const [dropdownOpen, setOpen] = useState(false);
  const toggleDro = () => setOpen(!dropdownOpen);

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const [isOpenbtn, setIsOpenBtn] = useState(false);
  const togglebtn = () => setIsOpenBtn(!isOpenbtn);

  const [isOpenbtnD, setIsOpenBtnD] = useState(false);
  const togglebtnD = () => setIsOpenBtnD(!isOpenbtnD);

  const [isOpenbtnJ, setIsOpenBtnJ] = useState(false);
  const togglebtnJ = () => setIsOpenBtnJ(!isOpenbtnJ);

  const { postList, here } = props;
  const herepath= here;
  const indexCardList = postList.edges.filter(edge => edge.node.frontmatter.type && edge.node.frontmatter.type === "indexCard");
  const procedureCategoryList = postList.edges.filter(edge => edge.node.frontmatter.childrenPath && edge.node.frontmatter.childrenPath === "/tramites/");
  const otherList = indexCardList.filter(edge => !edge.node.frontmatter.childrenPath);

  const shift = indexCardList.filter(edge => edge.node.frontmatter.childrenPath=== "/shift/");
  const generalList = postList.edges.filter(edge => edge.node.frontmatter.fatherPath && edge.node.frontmatter.fatherPath === "/general/");
  const dniList = postList.edges.filter(edge => edge.node.frontmatter.fatherPath && edge.node.frontmatter.fatherPath === "/dni/");
  const actaProcedure = postList.edges.filter(edge => edge.node.frontmatter.childrenPath && edge.node.frontmatter.childrenPath === "/acta/")[0];

  sortListName(dniList)
  const judicialList = postList.edges.filter(edge => edge.node.frontmatter.fatherPath && edge.node.frontmatter.fatherPath === "/judicial/");
  var lineUp= "lineUp";
  if(here!=="/tramites/"){
    lineUp= "";
  }

  return (
    <Navbar color="light" light expand="md" className="title" >
      <Container>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mr-auto" navbar>
            {procedureCategoryList.map(({ node }, i) => (
              <UncontrolledDropdown>
                <DropdownToggle className={"nav-link navbarbtn " + lineUp} caret> {node.frontmatter.title} </DropdownToggle>
                <DropdownMenu>
                  <NavItem> <div className="nav-link pointer" color="light" onClick={togglebtn} >Trámites Generales</div></NavItem>
                  <Collapse isOpen={isOpenbtn}>
                    <Card>
                      <CardBody>
                        {generalList.map(({ node }, i) => (
                          <DropdownItem tag="a" href={node.fields.slug}> {node.frontmatter.title}</DropdownItem>
                        ))}
                      </CardBody>
                    </Card>
                  </Collapse>
                  <DropdownItem divider />
                  <NavItem><div className="nav-link pointer" color="light" onClick={togglebtnJ} >Trámites de la Mesa Judicial</div></NavItem>
                  <Collapse isOpen={isOpenbtnJ}>
                    <Card>
                      <CardBody>
                        {judicialList.map(({ node }, i) => (
                          <DropdownItem tag="a" href={node.fields.slug}> {node.frontmatter.title}</DropdownItem>
                        ))}
                      </CardBody>
                    </Card>
                  </Collapse>
                  <DropdownItem divider />
                  <NavItem> <div className="nav-link pointer" color="light" onClick={togglebtnD} >Trámites DNI</div></NavItem>
                  <Collapse isOpen={isOpenbtnD}>
                    <Card>
                      <CardBody>
                        {dniList.map(({ node }, i) => (
                          <DropdownItem tag="a" href={node.fields.slug}> {node.frontmatter.title}</DropdownItem>
                        ))}
                      </CardBody>
                    </Card>
                  </Collapse>
                  <DropdownItem divider />
                  <DropdownItem tag="a" href={actaProcedure.node.fields.slug} className="padding-05"> {actaProcedure.node.frontmatter.title}</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            ))}
              {otherList.map(({ node }, i) => (
              <CustomNavItem link={node.fields.slug} name={node.frontmatter.title} className="nav-link" here={herepath}/>
              ))}
             {shift.map(({ node }, i) => (
                 node.frontmatter.shift && 
                                    
               <UncontrolledDropdown >
                <DropdownToggle className="nav-link navbarbtn" caret> {node.frontmatter.title} </DropdownToggle>
                   <DropdownMenu>
                 
                     <DropdownItem tag="a" href={node.frontmatter.linkGetShifts}>Solicitar Turno</DropdownItem>
                     <DropdownItem tag="a" href={node.frontmatter.linkLookShifts}>Consultar Turno</DropdownItem>
                  </DropdownMenu>
                 </UncontrolledDropdown >
              ))}
              <CustomNavItem link="/virtualPayments/" name="Pago Virtual" className="nav-link" here={herepath}/>
          </Nav>
          
        </Collapse>
      </Container>
      </Navbar>
  );
}

export default Header;
